import React, { useState, useEffect } from 'react';
import { Button, Tooltip, Typography, notification } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useParams, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { get } from 'lodash';
import ImageWithCustomToolbar from '../Heatprofile/Imageviewer';
import { fetchHeatProfileList } from '../../redux/heatProfile/action';

const { Title } = Typography;

const HeatProfileImageViewer = (props) => {
  const { id } = useParams();
  const history = useHistory();
  const { projectList, onProjectList } = props;

  const [selectedHeatProfileRow, setSelectedHeatProfileRow] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    console.log('HeatProfileImageViewer component mounted');
    return () => {
      console.log('HeatProfileImageViewer component unmounted');
    };
  }, []);

  useEffect(() => {
    // Fetch all records to find the one with matching ID
    const fetchRecord = async () => {
      try {
        console.log('HeatProfileImageViewer: Starting to fetch heat profile list');
        console.log('HeatProfileImageViewer: Looking for ID:', id, 'Type:', typeof id);

        const obj = {
          pageSize: 100000,
          pageNumber: 1,
        };
        console.log('HeatProfileImageViewer: Fetching with params:', obj);

        await onProjectList(obj);
        console.log('HeatProfileImageViewer: Fetch completed successfully');
      } catch (error) {
        console.error('HeatProfileImageViewer: Error fetching heat profile list:', error);
        console.error('HeatProfileImageViewer: Error details:', {
          message: error.message,
          stack: error.stack,
          id: id,
        });
        setIsLoading(false);
      }
    };

    fetchRecord();
  }, [onProjectList, id]);

  useEffect(() => {
    console.log('HeatProfileImageViewer: projectList changed, length:', projectList?.length);
    console.log('HeatProfileImageViewer: Current ID being searched:', id);
    console.log('HeatProfileImageViewer: projectList sample:', projectList?.slice(0, 3));

    if (projectList && projectList.length > 0) {
      // Find the record with matching ID
      const record = projectList.find((item) => {
        const itemId = item.id;
        const searchId = parseInt(id);
        const isMatch = itemId === searchId;

        console.log('HeatProfileImageViewer: Checking item:', {
          itemId: itemId,
          itemIdType: typeof itemId,
          searchId: searchId,
          searchIdType: typeof searchId,
          isMatch: isMatch,
        });

        return isMatch;
      });

      console.log('HeatProfileImageViewer: Found record:', record);

      if (record) {
        console.log('HeatProfileImageViewer: Setting selected record:', record);
        setSelectedHeatProfileRow(record);
      } else {
        console.error('HeatProfileImageViewer: Record not found!', {
          searchedId: id,
          searchedIdType: typeof id,
          parsedId: parseInt(id),
          totalRecords: projectList.length,
          availableIds: projectList.map((item) => item.id).slice(0, 10), // First 10 IDs for debugging
          projectListKeys: Object.keys(projectList[0] || {}),
        });

        // If record not found, show error
        notification.error({
          message: 'Record not found',
          description: `No heat profile record found with ID: ${id}`,
        });
      }
      setIsLoading(false);
    } else {
      console.log('HeatProfileImageViewer: projectList is empty or null:', {
        projectList: projectList,
        length: projectList?.length,
      });
    }
  }, [projectList, id]);

  if (isLoading) {
    return (
      <div className="flex-auto">
        <div className="d-flex mb-3 align-items-center tab-content-title">
          <div className="back_heatp_modal">
            <Tooltip title={'Back'}>
              <ArrowLeftOutlined
                onClick={() => {
                  history.push('/heat-profile');
                }}
              />
            </Tooltip>
          </div>
          <Title
            className="mb-0 add-new-calibration"
            level={3}
            style={{ paddingLeft: '25px', paddingTop: '5px' }}
          >
            Loading Image Viewer...
          </Title>
        </div>
        <div className="custom-line" />
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
          }}
        >
          <div>Loading...</div>
        </div>
      </div>
    );
  }

  if (!selectedHeatProfileRow) {
    return (
      <div className="flex-auto">
        <div className="d-flex mb-3 align-items-center tab-content-title">
          <div className="back_heatp_modal">
            <Tooltip title={'Back'}>
              <ArrowLeftOutlined
                onClick={() => {
                  history.push('/heat-profile');
                }}
              />
            </Tooltip>
          </div>
          <Title
            className="mb-0 add-new-calibration"
            level={3}
            style={{ paddingLeft: '25px', paddingTop: '5px' }}
          >
            Record Not Found
          </Title>
        </div>
        <div className="custom-line" />
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
          }}
        >
          <div>The requested heat profile record could not be found.</div>
        </div>
      </div>
    );
  }

  if (!selectedHeatProfileRow.imageFileDetails?.s3Url) {
    return (
      <div className="flex-auto">
        <div className="d-flex mb-3 align-items-center tab-content-title">
          <div className="back_heatp_modal">
            <Tooltip title={'Back'}>
              <ArrowLeftOutlined
                onClick={() => {
                  history.push('/heat-profile');
                }}
              />
            </Tooltip>
          </div>
          <Title
            className="mb-0 add-new-calibration"
            level={3}
            style={{ paddingLeft: '25px', paddingTop: '5px' }}
          >
            No Image Available
          </Title>
        </div>
        <div className="custom-line" />
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
          }}
        >
          <div>No image file is available for this heat profile record.</div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex-auto">
      <div className="d-flex mb-3 align-items-center tab-content-title">
        <Title
          className="mb-0 add-new-calibration"
          level={3}
          style={{ paddingLeft: '25px', paddingTop: '5px' }}
        >
          Heat Profile Image Viewer - {selectedHeatProfileRow.reportNumber || 'Image Document'}
        </Title>
      </div>
      <div className="custom-line" />
      <div className="addTeamDetails">
        <ImageWithCustomToolbar src={selectedHeatProfileRow.imageFileDetails.s3Url} />
      </div>
    </div>
  );
};

const mapStateToProps = ({ heatProfileReducer }) => {
  const projectList = get(heatProfileReducer, 'heatProfileList', []);
  return {
    projectList,
  };
};

const mapDispatchToProps = {
  onProjectList: fetchHeatProfileList,
};

export default connect(mapStateToProps, mapDispatchToProps)(HeatProfileImageViewer);
